
(function () {

    // check if the implementation is available
    if (typeof Promise.prototype['finally'] === 'function') {
        return;
    }

    // implementation
    Promise.prototype['finally'] = function (callback) {
        const constructor = this.constructor;

        return this.then(function (value) {
            return constructor.resolve(callback()).then(function () {
                return value;
            });
        }, function (reason) {
            return constructor.resolve(callback()).then(function () {
                throw reason;
            });
        });
    };
}());
